<template>
  <div class="tab" ref="tab" :class="{ plain: plain}">
    <div class="wrapper">
      <span class="block" ref="block" />
      <span
        v-for="(item, index) in items"
        :key="index"
        ref="items"
        class="tab-item"
        @click="$emit('input', index)"
        v-text="item"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "items", "plain"],
  watch: {
    value: {
      handler: function (val) {
        this.switchTab(val)
      }
    }
  },
  mounted() {
    if (Number.isInteger(this.value)) {
      this.switchTab(this.value)
    } else {
      this.$emit("input", 0)
    }
  },
  methods: {
    switchTab(index) {
      const active = "active"
      const el = this.$refs.items[index]

      this.$refs.items.forEach(el => el.classList.remove(active))
      const x = index * el.clientWidth
      this.$refs.block.style.transform = `translateX(${x}px)`
      el.classList.add(active)
    }
  }
}
</script>

<style lang="scss" scoped>
.tab {
  display: inline-block;

  .wrapper {
    border-radius: 30px;
    background: #e6e6e6;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  span {
    width: 80px;
    height: 35px;
  }

  .block {
    border-radius: 50px;
    border: 1px solid #e6e6e6;
    position: absolute;
    background: $red;
    top: 0;
    left: 0;
    transition: transform 0.3s;
    box-shadow: 0 0 20px -5px #cacaca;
  }

  .tab-item {
    z-index: 1;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    color: grey;
    &:active {
      transform: scale(0.9);
    }
  }

  .active {
    font-weight: bold;
    color: white;
    &:active {
      transform: none;
    }
  }
}

.plain {
  .wrapper {
    .block {
      background: white;
    }
    .active {
      color: $black;
    }
  }
}
</style>